import { Header } from './components/layout/Header';
import FloatingLogo from './components/layout/FloatingLogo';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import AgeGate from './components/ui/AgeGate';

function App() {
  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      <AgeGate />
      <Header />
      <FloatingLogo />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
